import {AfterViewInit, Component,  OnDestroy, Input, OnInit} from '@angular/core';
import {StreamsService}  from "../../services/streams.service";
import {StreamProject, StreamAccessKey} from "../../interfaces";
import { ClipboardService } from 'ngx-clipboard'
import { NbGlobalPosition, NbDialogService, NbToastrService } from '@nebular/theme';
 import {AuthService}  from "../../services/auth.service";
 
@Component({
  selector: 'app-stream-donate-control',
  templateUrl: './stream-donate-control.component.html',
  styleUrls: ['./stream-donate-control.component.scss'],
})
export class StreamDonateControlComponent implements OnInit, OnDestroy{


   
  @Input() stream: StreamProject
  @Input() socket: any = null
 subscribeSetDonate$:any = null

loading:boolean = false
donateOn:boolean = false


   constructor(
    public streamsService: StreamsService,
     public authService : AuthService,
    private toastrService: NbToastrService

    ){
  }
 

   

 toggleDonateOn(){
	if(this.donateOn){
          this.setDonate(true)
	}else{
          this.setDonate(false)
	}
 }


  setDonate(donate){
    
    this.loading = true

	if( this.subscribeSetDonate$){
      this.subscribeSetDonate$.unsubscribe()
     }
    this.subscribeSetDonate$ = this.streamsService.updateDonateMode(this.stream._id, donate).subscribe((stream: StreamProject)=>{
   


            this.stream.donateMode = stream.donateMode
		this.donateOn = stream.donateMode

		if(this.socket){
		//this.socket.emit('changeSettings',{deleteOnComplete: stream.deleteOnComplete, viewersInWatch: stream.viewersInWatch  })
		this.socket.emit('changeDonateState', stream.donateMode)
	}
  
      this.loading = false
    },(error)=>{
      this.loading = false

      // Donations settle to the author's own account at the bank, so the server
      // refuses them until onboarding is finished and says why - see the sale
      // control. Back to what is actually stored: a switch left in a position the
      // server refused would have the author waiting for donations that cannot
      // arrive.
      this.donateOn = this.stream.donateMode === true

      this.toastrService.show('',(error && error.error && error.error.message) || 'Сталася помилка сервера',{
        status: 'danger',
        icon:'',
        position: <NbGlobalPosition>'bottom-right'
          })
    })
  }


	 
  ngOnInit() {


		this.donateOn = this.stream.donateMode

  }


   ngOnDestroy() {
    if( this.subscribeSetDonate$){
      this.subscribeSetDonate$.unsubscribe()
     }
   }
 

 

  
}
